import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { FilterProjectInfoGroupDto } from 'src/app/web/interfaces/project/list/filterProjectInfoGroupDto';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import { ErrorService } from 'src/app/shared/services/errors.service';

class listGroup1{
  projects_id:number
  id_group:number
}
class listGroup2{
  projects_id:number
  name_new_group:string
}

@Component({
  selector: 'app-group-popup-project',
  templateUrl: './group-popup-project.component.html',
  styleUrls: ['./group-popup-project.component.scss']
})
export class GroupPopupProjectComponent implements OnInit {


  closeResult = '';
  idProject: number;
  conGrupo = true;
  sinGrupo = false;
  vincularEquipFormV: FormGroup;
  vincularEquipFormN: FormGroup;
  vincularEquip1 : listGroup1;
  vincularEquip2 : listGroup2;
  listGroup: FilterProjectInfoGroupDto[] = []
  

  @ViewChild('defaultTabButtons')
  public defaultTabButtonsTpl: TemplateRef<any>;
  
  constructor(config: NgbModalConfig, 
              private modalService: NgbModal,  
              private apiService: ApiServiceProject,
              private http: HttpClient,
              private router: Router,
              private route: ActivatedRoute,
              private spinner: NgxSpinnerService,
              private fb: FormBuilder,
              private errorService:ErrorService) {

    config.backdrop = 'static';
    config.keyboard = false;
   }


  ngOnInit(): void {
    this.vincularEquipFormV = this.fb.group({
      projects_id: [0],
      id_group: [0],
    });

    this.vincularEquipFormN = this.fb.group({
      projects_id: [0],
      name_new_group: [''],
    });
    
   this.apiService.getService('list-project-group-option')
   .subscribe({
     next: (rs: any) => {
       if (rs) {
        this.listGroup = rs.listProjectGroups;
       } else {
         Swal.fire({
          title:  rs.error,
          text: '',
          icon: 'error',
          heightAuto: false
          });
       }
     },
     error: (error) => {
      this.errorService.error(error);
     },
   });

 

  }

  public open(id:number) {

    this.idProject = id;

    this.apiService.getService('project-info?id_project='+id)
    .subscribe({
      next: (rs: any) => {
        if (rs) {
       if (rs.group == null) {
        this.vincularEquipFormV.patchValue({
          id_group : 0
        });
       }else{
        this.listGroup.map((dato:any)=>{
         
          if (dato.name == rs.group) {
            this.vincularEquipFormV.patchValue({
              id_group : dato.id
            });

          }

         });
       }
         

        } else {
          Swal.fire({
          title:  rs.error,
          text: '',
          icon: 'error',
          heightAuto: false
          });
        }
      },
      error: (error) => {
       this.errorService.error(error);
      },
    });
    

    this.modalService.open(this.defaultTabButtonsTpl, { ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  vincularGroup() {
    this.conGrupo = true;
    this.sinGrupo = false;

  }

  nuevoGroup() {
    this.sinGrupo = true;
    this.conGrupo = false;
  }

  formSubmitC(): void {

    if (this.vincularEquipFormV.value.id_group === 0) {
      this.spinner.hide();
      Swal.fire({title: 'Debe seleccionar un grupo' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

    this.vincularEquip1 = this.vincularEquipFormV.value;
    this.vincularEquip1.projects_id = this.idProject;
    this.vincularEquip1.id_group = this.vincularEquipFormV.value.id_group;

    this.apiService
    .postService('update-project-group-assign', this.vincularEquip1)
    .subscribe({
      next: (data: any) => {
        this.spinner.hide();
        Swal.fire({title:'Se ha asignado correctamente el grupo' ,text: '',icon: 'success',heightAuto: false})
        .then(() => [this.router.navigate(['/pdg/project/list/'])
          ]);
          location.reload()
      },
      error: (error) => {
        this.errorService.error(error);
      }
    });

  }
  formSubmitS(): void {

    if (this.vincularEquipFormN.value.name_new_group === "") {
      this.spinner.hide();
      Swal.fire({title: 'Debe ingresar un nombre' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
  
    this.vincularEquip2 = this.vincularEquipFormN.value;
    this.vincularEquip2.projects_id = this.idProject;
    this.vincularEquip2.name_new_group = this.vincularEquipFormN.value.name_new_group;

    this.apiService
    .postService('create-project-group-assign', this.vincularEquip2)
    .subscribe({
      next: (data: any) => {
        this.spinner.hide();
        Swal.fire({title:'Se ha creado el grupo y asignado correctamente' ,text: '',icon: 'success',heightAuto: false})
          .then(() => [this.router.navigate(['/pdg/project/list/'])
          ]);
          location.reload()

      },
      error: (error) => {
        this.errorService.error(error);
      }
    });
  }

}

